<template>
	<transition
			appear
			:appear-active-class="$_inpCmb_styleInputComboboxAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputCombobox-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-combobox 
							v-model="$store.state.input.data[contentKey].answer"

							return-object

							:background-color="$_inpCmb_styleComboboxBackgroundColor"
							:chips="$_inpCmb_styleComboboxChips"
							:clearable="$_inpCmb_styleComboboxClearable"
							:color="$_inpCmb_styleComboboxColor"
							:deletable-chips="$_inpCmb_styleComboboxDeletableChips"
							:dark="$_inpCmb_styleComboboxDark"
							:dense="$_inpCmb_styleComboboxDense"
							:filled="$_inpCmb_styleComboboxFilled"
							:flat="$_inpCmb_styleComboboxFlat"
							:light="$_inpCmb_styleComboboxLight"
							:outlined="$_inpCmb_styleComboboxOutlined"
							:small-chips="$_inpCmb_styleComboboxSmallChips"
							:solo="$_inpCmb_styleComboboxSolo"
							:solo-inverted="$_inpCmb_styleComboboxSoloInverted"

							:append-icon="$_inpCmb_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpCmb_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpCmb_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpCmb_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpCmb_langParamHint(contents[contentKey].params)"
							:mask="$_inpCmb_langParamMask(contents[contentKey].params)"
							:message="$_inpCmb_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpCmb_langParamPlaceholder(contents[contentKey].params)"
							:prefix="$_inpCmb_langParamPrefix(contents[contentKey].params)"
							:suffix="$_inpCmb_langParamSuffix(contents[contentKey].params)"
							:type="$_inpCmb_langParamType(contents[contentKey].params)"

							item-avater="icon"
							item-text="text"
							item-value="key"
							:items="arrayObject(contents[contentKey].options)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputCombobox',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpCmb_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamMask() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.mask;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpCmb_langParamType() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.type;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpCmb_styleInputCombobox() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputCombobox')
				}
			},
			$_inpCmb_styleInputComboboxAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpCmb_styleInputCombobox()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpCmb_styleCombobox() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'combobox')
			},
			$_inpCmb_styleComboboxBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpCmb_styleComboboxChips() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.chips)
			},
			$_inpCmb_styleComboboxClearable() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpCmb_styleComboboxColor() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpCmb_styleComboboxDeletableChips() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.deletableChips)
			},
			$_inpCmb_styleComboboxDark() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpCmb_styleComboboxDense() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dense)
			},
			$_inpCmb_styleComboboxFilled() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpCmb_styleComboboxFlat() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpCmb_styleComboboxLight() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpCmb_styleComboboxOutlined() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpCmb_styleComboboxSmallChips() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.smallChips)
			},
			$_inpCmb_styleComboboxSolo() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpCmb_styleComboboxSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpCmb_styleCombobox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpCmb_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmb_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmb_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpCmb_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
</style>
